import shareHelper from "@/helper/shareHelper";
export const mutations = {
  MutationSetIsActiveAlertRedirect(state, isActiveAlertRedirect) {
    state.isActiveAlertRedirect = isActiveAlertRedirect;
    if (isActiveAlertRedirect) {
      shareHelper.AddDetectTabClosing();
    } else {
      shareHelper.RemoveDetectTabClosing();
    }
  },
};
